import { render } from "./RenduView.vue?vue&type=template&id=708e2c31"
import script from "./RenduView.vue?vue&type=script&lang=js"
export * from "./RenduView.vue?vue&type=script&lang=js"

import "./RenduView.vue?vue&type=style&index=0&id=708e2c31&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__